

export const ApplyDistributionToTask = (task, distributionCode, resultHandler) => {
  let getAPI = '/api/distributions/calculatePlan/' + distributionCode + '';
  if (process.env.NODE_ENV !== 'production') {
    getAPI = 'http://localhost:7071/api/distributions/calculatePlan/' + distributionCode + '';
  }
  fetch(getAPI, {
    method: 'POST',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(task.toJS())
  }).then(response => {
    if (!response.ok) {
      response.text()
        .then(text => { throw Error(response.statusText + ': ' + text) });
    } else {
      response.json()
        .then(parsedResponse => resultHandler(parsedResponse));
    }
  });
}

export const ApplyDistributionToTaskPreBaseline = (task, distributionCode, resultHandler) => {
  let preBaselines = task.project.preBaselines;
  let periodNumber = task.plannedStartPeriod;
  for (let i = preBaselines.length - 1; i >= 0; i--) {
    if(!preBaselines[i].isArchive) {
      periodNumber = preBaselines[i].preBaselinePeriod + 1;
      break;
    }
  }
  let getAPI = '/api/distributions/calculatePlan/' + distributionCode + '/planStart/' + periodNumber + '';
  if (process.env.NODE_ENV !== 'production') {
    getAPI = 'http://localhost:7071/api/distributions/calculatePlan/' + distributionCode + '/planStart/' + periodNumber + '';
  }
  fetch(getAPI, {
    method: 'POST',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(task.toJS())
  }).then(response => {
    if (!response.ok) {
      response.text()
        .then(text => { throw Error(response.statusText + ': ' + text) });
    } else {
      response.json()
        .then(parsedResponse => resultHandler(parsedResponse));
    }
  });
}

export const UpdateTask = async (project, task, resultHandler) => {
  let getAPI = '/api/projects/tasks/'+ task.id.toString()+ '/calculateperiods';
  if (process.env.NODE_ENV !== 'production') {
    getAPI = 'http://localhost:7071' + getAPI;
  }
  const response = await fetch(getAPI, {
    method: 'POST',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(project.toJS())
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(response.statusText + ': ' + text);
  } else {
    const parsedResponse = await response.json();
    resultHandler(parsedResponse);
  }
};

export const GetTaskAnalysis = async (taskId, resultHandler) => {
  let getAPI = '/api/task/'+ taskId+ '/analysis';
  if (process.env.NODE_ENV !== 'production') {
    getAPI = 'http://localhost:7071' + getAPI;
  }
  const response = await fetch(getAPI, {
    method: 'GET',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    }
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(response.statusText + ': ' + text);
  } else {
    const parsedResponse = await response.json();
    resultHandler(parsedResponse);
  }
};

export const GetFAC = async (taskId, resultHandler) => {
  let getAPI = '/api/task/'+ taskId+ '/FAC';
  if (process.env.NODE_ENV !== 'production') {
    getAPI = 'http://localhost:7071' + getAPI;
  }
  const response = await fetch(getAPI, {
    method: 'GET',
    headers: {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json'
    }
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(response.statusText + ': ' + text);
  } else {
    const parsedResponse = await response.json();
    resultHandler(parsedResponse);
  }
};
